/* eslint-disable react/prop-types */
import React from 'react';
import { nanoid } from 'nanoid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';

export default function CommentsList({ comments }) {
    return (
        <>
            {/* userProfilePicture */}
            <div>
                {!comments ||
                    (comments.length === 0 && (
                        <p className="py-4 px-2">No Comments Available</p>
                    ))}
                <List key={nanoid()}>
                    {comments &&
                        comments.map((comment) => (
                            <div key={nanoid()} className="mt-4 mx-2">
                                <ListItem>
                                    <div className="row">
                                        <ListItemAvatar>
                                            <Avatar
                                                src={comment.userProfilePicture}
                                            />
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary={comment.userFullName}
                                            secondary={new Date(
                                                comment.updatedAt,
                                            ).toDateString()}
                                        />
                                    </div>
                                </ListItem>
                                <div className="mx-2 row">
                                    <Typography>{comment.text}</Typography>
                                </div>
                            </div>
                        ))}
                </List>
            </div>
        </>
    );
}
